import styled from 'styled-components'

const Title = styled.div`
    color: red;
    font-size: 26px;
`
export default Title;


// WEBPACK FOOTER //
// ./src/components/UI/Elements/Title.js